import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Keyboard } from "lucide-react";
import { useDismissPopover } from "../hooks/useDismissPopover";
import { SHORTCUTS } from "../lib/shortcuts";

export function ShortcutsPopover() {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState<{ top: number; right: number } | null>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const panelRef = useRef<HTMLDivElement>(null);

  useDismissPopover({
    open,
    triggerRef,
    panelRef,
    onDismiss: () => setOpen(false),
  });

  const toggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!open) {
      const r = e.currentTarget.getBoundingClientRect();
      setPos({ top: r.bottom + 4, right: window.innerWidth - r.right });
    }
    setOpen((o) => !o);
  };

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className="topbar__shortcuts-btn"
        onClick={toggle}
        aria-label="Keyboard shortcuts"
      >
        <Keyboard size={14} aria-hidden />
      </button>
      {open &&
        pos &&
        createPortal(
          <div
            ref={panelRef}
            className="shortcuts-popover"
            style={{ top: pos.top, right: pos.right }}
          >
            {SHORTCUTS.map((s) => (
              <div key={s.keys} className="shortcuts-popover__row">
                <span className="shortcuts-popover__key">{s.keys}</span>
                <span className="shortcuts-popover__description">
                  {s.description}
                </span>
              </div>
            ))}
          </div>,
          document.body,
        )}
    </>
  );
}
